import { usePluggyStatus } from '../pluggy/usePluggyStatus'
import { Link } from 'react-router-dom'
import { Badge } from '../../components/ui/Badge'
import { Button } from '../../components/ui/Button'
import { Card, CardBody } from '../../components/ui/Card'
import { cn } from '../../lib/utils'
import { PageHeader } from '../../layout/PageHeader'
import { TUTORIAIS, type Tutorial } from '../../tutoriais'
import { useTutorial } from './tutorialContext'
import { useOnboarding, useTutoriaisPlanos } from './useOnboarding'

const ICONES: Record<Tutorial['icone'], string> = {
  estrela: 'ri-star-line',
  nota: 'ri-receipt-line',
  lista: 'ri-shopping-cart-2-line',
  carro: 'ri-car-line',
  lancamento: 'ri-exchange-dollar-line',
  recorrencia: 'ri-repeat-line',
  banco: 'ri-bank-line',
}

export function TutoriaisPage() {
  const pluggy = usePluggyStatus()
  const { data: onboarding } = useOnboarding()
  const { data: planos } = useTutoriaisPlanos()
  const { iniciarTutorial } = useTutorial()

  return (
    <div className="space-y-4">
      <PageHeader title="Tutoriais" />
      <p className="text-13 text-muted">Revise qualquer fluxo quando quiser.</p>
      <div className="grid gap-4 lg:grid-cols-2">
        {TUTORIAIS.map((t) => {
          const plano = t.recurso ? planos?.[t.recurso] : undefined
          const bloqueado = plano?.liberado === false
          // O guia de conectar banco leva a telas que a Pluggy desligada esconde.
          const pluggyOff = t.id === 'conectar-banco' && !pluggy.ativa
          const estado = onboarding?.estado.tutoriais[t.id]
          const visto = !!estado?.vistoEm || !!estado?.concluido
          const passos = t.id === 'primeiros-passos' ? onboarding?.passos : undefined
          const feitos = passos?.filter((p) => p.concluido).length ?? 0
          const parcial = !!passos && passos.length > 0 && feitos < passos.length

          return (
            <Card key={t.id} className={cn(bloqueado && 'border border-dashed border-border bg-transparent shadow-none')}>
              <CardBody className="flex flex-wrap items-center gap-3">
                <span className={cn('flex h-11 w-11 flex-shrink-0 items-center justify-center rounded text-xl', bloqueado ? 'bg-surface2 text-muted' : 'bg-primary/10 text-primary')}>
                  <i className={bloqueado ? 'ri-lock-line' : ICONES[t.icone]} aria-hidden />
                </span>
                <div className="min-w-0 flex-1">
                  <p className={cn('flex flex-wrap items-center gap-2 text-15 font-medium', bloqueado ? 'text-muted' : 'text-white')}>
                    {t.titulo}
                    {!bloqueado && parcial && <Badge variant="primary">{feitos} de {passos!.length}</Badge>}
                    {!bloqueado && !parcial && visto && <Badge variant="income">Visto</Badge>}
                  </p>
                  <p className="text-13 text-muted">{t.resumo}</p>
                  {!bloqueado && pluggyOff && <p className="mt-0.5 text-13 text-warning">{pluggy.mensagem}</p>}
                  {bloqueado && (
                    <p className="mt-0.5 text-13 text-warning">
                      {plano?.planoQueLibera ? `Disponível no plano ${plano.planoQueLibera.nome}` : 'Não disponível no seu plano'}
                    </p>
                  )}
                </div>
                {bloqueado ? (
                  plano?.planoQueLibera && (
                    <Link to="/plano" className="inline-flex h-8 items-center rounded bg-primary/10 px-3 text-xs font-medium text-primary hover:bg-primary hover:text-bg">
                      Ver planos
                    </Link>
                  )
                ) : (
                  <Button size="sm" variant="soft-primary" icon={visto ? 'ri-replay-10-line' : 'ri-play-line'} disabled={pluggyOff} onClick={() => iniciarTutorial(t.id)}>
                    {visto ? 'Rever' : 'Iniciar'}
                  </Button>
                )}
              </CardBody>
            </Card>
          )
        })}
      </div>
    </div>
  )
}
